import {createStore} from 'vuex'
import auth from './modules/auth'
import firebase from '@/firebase'
const db = firebase.firestore()
const storageRef = firebase.storage().ref()
export default createStore({
    state: {
      showMaterial: false,
      showOverlay: false,
      showVideo:false,
      checkSintomas:false,
      showTyC: false,
        elementos: [],
        elemento: null,
    },
    getters: {},
    mutations: {
      mater(state){
        state.showMaterial = !state.showMaterial
         },
       modal(state){
        state.showOverlay = !state.showOverlay
       },
       video(state){
         state.showVideo =!state.showVideo
       },
       symptom(state){
        state.checkSintomas = true
       },
       tyc(state){
        state.showTyC = !state.showTyC
       },
        SET_ELEMENTOS(state, payload){
            state.elementos = payload
        },
        ADD_ELEMENTO(state, payload) {
            state.elementos.push(payload)
        },
        SET_ELEMENTO(state, payload) {
            state.elemento = payload
        },
        UPDATE_ELEMENTO(state, payload) {
            state.elementos = state.elementos.map(x => x.id === payload.id ? payload : x)
        },
        DELETE_ELEMENTO(state, payload) {
            state.elementos = state.elementos.filter(x => x.id !== payload)
        }
    },
    actions: {
        async getElementos({commit}){
            try{
                const res =  await db.collection('Elementos').get()
                const elementos =  await res.docs.map(doc =>{return{...doc.data(),id:doc.id}} )
                console.log(elementos)
                commit('SET_ELEMENTOS', elementos)
            }catch (e) {
                console.log(e)
            }
        },
         async addElemento({commit} ,elemento){
            try{
                if(elemento.file){
                    const fileRef = storageRef.child('PDF').child(elemento.file.name)
                    await fileRef.put(elemento.file)
                    const fileUrl = await fileRef.getDownloadURL()
                    const newElemento = {
                        titulo: elemento.titulo,
                        descripcion: elemento.descripcion,
                        link: fileUrl,
                        tipo: elemento.tipo,
                        fecha: new Date()
                    }
                    const res = await db.collection('Elementos').add(newElemento)
                    newElemento.fecha = new firebase.firestore.Timestamp.fromDate(new Date())
                    commit('ADD_ELEMENTO', {...newElemento, id:res.id})
                }else {
                    const newElemento = {
                        titulo: elemento.titulo,
                        descripcion: elemento.descripcion,
                        link: elemento.link,
                        tipo: elemento.tipo,
                        fecha: new Date()
                    }
                    const res = await db.collection('Elementos').add(newElemento)
                    newElemento.fecha = new firebase.firestore.Timestamp.fromDate(new Date())
                    commit('ADD_ELEMENTO', {...newElemento, id: res.id})
                }
                return elemento
            }catch (e) {
                console.log(e)
                return e
            }
        },
        async deleteElemento({commit}, id){
            try {
                await db.collection('Elementos').doc(id).delete()
                commit('DELETE_ELEMENTO', id)
                return {}
            }catch (e){
                console.log(e)
                return e
            }
        },
        async updateElemento({commit},elemento){
            try {
                if(elemento.file){
                    const fileRef = storageRef.child('PDF').child(elemento.file.name)
                    await fileRef.put(elemento.file)
                    const fileUrl = await fileRef.getDownloadURL()
                    const newElemento = {
                        id:elemento.id,
                        titulo: elemento.titulo,
                        descripcion: elemento.descripcion,
                        link: fileUrl,
                        tipo: elemento.tipo,
                        fecha: new Date()
                    }
                    await db.collection('Elementos').doc(elemento.id).update(newElemento)
                    newElemento.fecha = new firebase.firestore.Timestamp.fromDate(new Date())
                    commit('UPDATE_ELEMENTO', newElemento )
                }else {
                    const newElemento = {
                        id:elemento.id,
                        titulo: elemento.titulo,
                        descripcion: elemento.descripcion,
                        link: elemento.link,
                        tipo: elemento.tipo,
                        fecha: new Date()
                    }
                    await db.collection('Elementos').doc(elemento.id).update(newElemento)
                    newElemento.fecha = new firebase.firestore.Timestamp.fromDate(new Date())
                    commit('UPDATE_ELEMENTO', newElemento)
                }
                return elemento
            }catch (e) {
                console.log(e)
                return e
            }
        }
    },
    modules: {
        auth
    }
})
